import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi';
import { computed } from 'vue';
import { createMovementTypesFromResource } from '../model/create-movement-types-from-resource.ts';
import type { ComputedMovementTypeData, ExpCardLabels, IMovementType, IMovementTypeGroup } from '../types';

export const useMovementTypes = (): ComputedMovementTypeData => {
  const { getMovementTypes } = useExperienceApi();

  const { data: movementTypesData } = useQuery({
    queryKey: ['movementTypes'],
    queryFn: async () => {
      const response = await getMovementTypes();

      if (response?.data) {
        return createMovementTypesFromResource(response.data);
      }

      return null;
    },
    retry: false,
  });

  const safeMovementTypes = computed(() => {
    const types = movementTypesData.value?.movementTypes || [];

    return types.filter((type): type is IMovementType => type !== null);
  });

  const safeMovementTypeGroups = computed(() => {
    const groups = movementTypesData.value?.movementTypeGroups || [];

    return groups.filter((group): group is IMovementTypeGroup => group !== null);
  });

  const movementTypesExpCardLabels = computed<ExpCardLabels>(() => {
    return (movementTypesData.value?.movementTypesExpCardLabels as ExpCardLabels) || ({} as ExpCardLabels);
  });

  return {
    movementTypes: safeMovementTypes,
    movementTypeGroups: safeMovementTypeGroups,
    movementTypesExpCardLabels,
  };
};
